
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Function to handle rendering the application
const renderApp = () => {
  const rootElement = document.getElementById("root");
  if (!rootElement) {
    console.error("Failed to find the root element");
    return;
  }
  
  try {
    // Clear any loading placeholder content after app is loaded
    const root = createRoot(rootElement);
    root.render(<App />);
    
    console.log("App successfully mounted to DOM");
  } catch (error) {
    console.error("Error rendering application:", error);
    // Display a user-friendly error message
    rootElement.innerHTML = `
      <div style="padding: 20px; text-align: center; font-family: sans-serif;">
        <h2>Oops! Something went wrong</h2>
        <p>We're sorry, but the application couldn't load properly. Please try refreshing the page.</p>
        <p>Error details: ${error instanceof Error ? error.message : 'Unknown error'}</p>
      </div>
    `;
  }
};

// Check if document is already loaded
if (document.readyState === 'complete' || document.readyState === 'interactive') {
  setTimeout(renderApp, 1);
} else {
  // Wait for DOM to be fully loaded
  document.addEventListener('DOMContentLoaded', renderApp);
}

// Add global error handler
window.addEventListener('error', (event) => {
  console.error('Global script error:', event.message);
  // Don't modify DOM here - let the error propagate to the try/catch in renderApp
});
